angular.module('picmonicng').directive('plsTrack', [
  '$uiViewScroll',
  function ($uiViewScroll) {
    return {
      restrict: 'E',
      scope: {
        track: '=',
        pathway: '=',
        picmonics: '=',
        primary: '=',
        scrollToType: '=',
        scrollToId: '=',
        isActive: '=?',
      },
      templateUrl: '/templates/directives/pls-track.html',
      link: function (scope, element) {
        if (scope.track.track_id == scope.track_id) {
          $uiViewScroll(element.find('.track-anchor'));
        }

        // if(scope.ugcPicmonics) {
        //     var parent = element.parent();
        //
        //     parent.on('scroll', checkIfSeen);
        //
        //     function checkIfSeen() {
        //       if(scope.ugcPicmonics && scope.UserService.user.user_id && scope.ugcFlag) {
        //           var child = $('pls-track').children('.pathways__verified-picmonics');
        //           if (!child.length) {
        //               parent.off('scroll', checkIfSeen);
        //               return;
        //           }
        //           var elementTop = child[0].offsetTop;
        //           var docViewTop = parent.scrollTop();
        //           var docViewBottom = docViewTop + parent.height();
        //           if (docViewBottom > elementTop) {
        //               scope.verifiedVisible = 1;
        //               parent.off('scroll', checkIfSeen);
        //           }
        //       }
        //     }
        //
        //     scope.$on('$destroy', function(){
        //       parent.off('scroll', checkIfSeen);
        //     });
        // }
      },
      controller: [
        '$scope',
        '$modal',
        '$cookies',
        'UserService',
        'PicmonicQueue',
        'BrowseService',
        'MarketOptionsConfig',
        'Tracks',
        'LearnService',
        '$state',
        '$filter',
        'ResourceUpgradeModalService',
        function (
          $scope,
          $modal,
          $cookies,
          UserService,
          PicmonicQueue,
          BrowseService,
          MarketOptionsConfig,
          Tracks,
          LearnService,
          $state,
          $filter,
          ResourceUpgradeModalService
        ) {
          $scope.LearnService = LearnService;
          $scope.UserService = UserService;
          $scope.BrowseService = BrowseService;
          $scope.isActive = $scope.isActive
            ? $scope.isActive
            : $scope.scrollToType == 'track' && $scope.scrollToId == $scope.track.track_id;
          $scope.onPublicPathways = false;
          //Checks the first part of state current name for a match to pathways market
          //*.course, *.books, *.boards all possible suffix
          if ($state.current.name.indexOf('app.pathways.market') > -1) {
            $scope.onPublicPathways = true;
          }

          // Show the onboarding tooltip for the first vUGC in a track
          $scope.ugcFound = false;
          angular.forEach($scope.picmonics, function (picmonic) {
            if (
              UserService.user.user_id &&
              !$scope.ugcFound &&
              picmonic.card_id >= 50000 &&
              picmonic.card_id < 1000000 &&
              !UserService.seen('onboarding_verified_ugc')
            ) {
              picmonic.showVerifiedPicmonicsOnboarding = true;
              $scope.ugcFound = true;
            }
          });

          $scope.learn = function (e, picmonic) {
            var newTab = false;
            if (e.shiftKey || e.ctrlKey || e.metaKey) {
              newTab = true;
            }

            if (picmonic && newTab) {
              PicmonicQueue.setAndPlay($scope.picmonics, picmonic.card_id, null, $scope.track.track_id, null, newTab);
              return;
            }

            if (UserService.user.user_id) {
              var event, data;
              if (picmonic) {
                event = 'Pathways Learn';
                data = 'Picmonic - ' + picmonic.name + ' (' + picmonic.card_id + ')';
              } else {
                event = 'Pathways Learn All';
                data = 'Track - ' + $scope.track.name + ' (' + $scope.track.track_id + ')';
              }
              send_ga('event', event, data);
              if (typeof atlasEvent !== 'undefined') {
                atlasEvent(event, data);
              } else {
                console.info('Action: ' + event + ' | ' + data);
              }
              // We use a directive to navigate, so just close the browse tab
              BrowseService.setOpen(false, false);
              if (
                UserService.user.playlist_mode != 'track' ||
                UserService.user.current_track_id != $scope.track.track_id
              ) {
                UserService.user.playlist_mode = 'track';
                UserService.user.current_track_id = $scope.track.track_id;
                UserService.user.$update();
              }

              if (picmonic) {
                PicmonicQueue.setAndPlay($scope.picmonics, picmonic.card_id, null, $scope.track.track_id);
              } else {
                PicmonicQueue.setAndPlay(
                  $filter('orderBy')($scope.picmonics, [
                    'viewed_flag',
                    'attempted_flag',
                    'mastered_flag',
                    'sort_order',
                  ]),
                  null,
                  null,
                  $scope.track.track_id
                );
              }
            } else {
              var lead = UserService.user.lead ? UserService.user.lead : $cookies.get('pls_user_lead');
              var market = MarketOptionsConfig.getMarketById(lead);
              send_ga('event', 'Pathways', 'No Account Modal');

              if (BrowseService.browseOpen) {
                $modal.open({
                  templateUrl: '/templates/modals/register-modal.html',
                  windowClass: 'registration-cta-modal full-screen-modal',
                  backdropClass: 'modal-body-reduced',
                  controller: 'RegisterModalController',
                  resolve: {
                    market_id: function () {
                      return lead;
                    },
                    copy: function () {
                      return null;
                    },
                    redirect: function () {
                      return (
                        '/learn/' +
                        picmonic.slug +
                        '?browse=' +
                        BrowseService.state +
                        '&browseParams=' +
                        JSON.stringify(BrowseService.params) +
                        '&browseOptions=' +
                        JSON.stringify({ open: false })
                      );
                    },
                    extraParams: function () {
                      return null;
                    },
                  },
                });
              } else {
                $state.go('.picmonic', {
                  card_id: picmonic.slug,
                  scroll_to: 'content',
                });
              }
            }
          };
        },
      ],
    };
  },
]);
